import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'shorter'
})
export class ShorterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return this.getShortened(value, args ? +args : 10)
  }

  getShortened(str: string, len: number) {
    return str && str.length > len ? str.substr(0, len) + '..' : str
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/utils/shorter.pipe.ts